function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1018.27 163.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M241.3,2c37.81,0,64,18.24,64,53.85,0,22.86-11.65,38-29,45.72l31.87,58.69h-42l-25.5-52.1H223.06v52.1H183.71V2ZM223.06,35.85V76.07h20.22c12.09,0,21.32-5.71,21.32-20.22,0-13.85-9.45-20-21.54-20Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.25,35.85V160.26H366.8V35.85H324.6V2H449.45V35.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.66,101.57c0,37.15-25.28,61.76-68.8,61.76-43.3,0-68.8-24.61-68.8-61.76V2h40.22V97.17c0,18.69,9.89,29.46,28.58,29.46s28.35-10.77,28.35-29.46V2h40.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707,2c37.81,0,64,18.24,64,53.85,0,22.86-11.65,38-29,45.72l31.88,58.69h-42l-25.49-52.1H688.8v52.1H649.46V2ZM688.8,35.85V76.07H709c12.09,0,21.32-5.71,21.32-20.22,0-13.85-9.45-20-21.54-20Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.53,160.26V2H907.28V35.85H843.76V64h54.29V96.1H843.76v30.33h66.82v33.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.45,0h1.76l80.44,160.46H118.47L98.25,116.72C91.66,102,85.06,87.7,81.33,76.27,78.91,81.55,69,106,64.18,116.72L44,160.46H0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.39,160.42c0-8.64.05-17.26,0-25.88,0-5-.5-10-.32-14.93.14-4.06.32-8.2,1.91-12.07a36,36,0,0,1,10.39-13.71,51.55,51.55,0,0,1,28.32-12.51c8.47-.93,17-1.49,25.46-2.22l14.12-1.23c-.12,1.83-.34,3.61-.35,5.38,0,9.21-.08,18.41,0,27.61,0,6.68,0,13.33-2.32,19.72-2.71,7.52-7.78,13.3-13.76,18.36-7.79,6.6-17,9.68-27,10.8-11.39,1.27-22.82.57-34.23.68C939.82,160.43,939.05,160.42,938.39,160.42Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.22711a32c3d8c2dbec8c7ab0781ddcb0.svg";
export { ForwardRef as ReactComponent };